import { MarkerProps } from "@cofano/cck";
import { Typography } from "@mui/material";

const GeofenceLabel = ({ label }: MarkerProps) => (
	<Typography
		sx={{
			color: "text.secondary",
			fontSize: 11,
			fontWeight: 600,
			pointerEvents: "none",
			position: "absolute",
			textAlign: "center",
			textShadow: "0 0 3px rgba(255, 255, 255, 0.9)",
			transform: "translate(-50%, -50%)",
			whiteSpace: "nowrap",
		}}>
		{label}
	</Typography>
);

export default GeofenceLabel;
